import { NoiumWordmark } from "./shared";
import { getProposalTexts, type ProposalLanguage } from "./i18n";

export function ProposalFooter({
  clientCompany,
  preparerName,
  preparerEmail,
  language,
}: {
  clientCompany: string | null;
  preparerName: string;
  preparerEmail: string;
  language: ProposalLanguage;
}) {
  const t = getProposalTexts(language).footer;
  return (
    <footer className="mx-auto max-w-5xl px-5 pb-12 sm:px-10 sm:pb-24">
      <div
        className="overflow-hidden rounded-2xl text-white"
        style={{ background: "#0E0E12" }}
      >
        <div className="px-6 py-7 sm:px-10 sm:py-10">
          <div className="font-mono text-[10px] font-semibold uppercase tracking-[0.16em] text-zinc-500">
            {t.eyebrow}
          </div>
          <p className="mt-3 max-w-xl text-[15px] leading-relaxed text-zinc-300 sm:text-lg">
            {clientCompany ? t.bodyWithCompany(clientCompany) : t.bodyNoCompany}
          </p>
          <div className="mt-7 flex flex-wrap items-center justify-between gap-4 border-t border-white/10 pt-6">
            <div className="min-w-0">
              <div className="break-words text-sm font-semibold text-white">
                {preparerName}
              </div>
              <div className="break-all font-mono text-xs text-zinc-400">
                {preparerEmail}
              </div>
            </div>
            <NoiumWordmark dark compact />
          </div>
        </div>
      </div>
      <div className="mt-6 text-center font-mono text-[10px] uppercase tracking-[0.14em] text-muted-foreground">
        © {new Date().getFullYear()} Noium · sales@noium.com
      </div>
    </footer>
  );
}
